

<div class="relative h-screen overflow-y-scroll">
  <slot />
</div>

<style>
  .bright {
    filter: brightness(3) invert(2) opacity(0.4);
    clip-path: polygon(20% 0%, 80% 0%, 100% 0, 100% 100%, 80% 100%, 0 100%, 0% 80%, 0% 20%);
  }
</style>